export default "__VITE_ASSET__BxO1C2eI__"